// extracted by mini-css-extract-plugin
module.exports = {"Primary":"Button_Primary__38CGK","active":"Button_active__1ycIr","Link":"Button_Link__1r-sr","WhiteText":"Button_WhiteText__37ZuL","BlackText":"Button_BlackText__3f_uh"};